const CUSTOM_PROMPT_KEY = 'balus.aiAssistant.customSystemPrompt';
const DEBUG_MESSAGE_KEY = 'balus.aiAssistant.debugMessageEnabled';
// 保存済みモデルを一斉リセットしたいときはサフィックス（YYYY-MM）を更新して旧キーを無効化する
const SELECTED_MODEL_KEY = 'balus.aiAssistant.selectedModel.2026-08';
const SELECTED_MODE_KEY = 'balus.aiAssistant.selectedMode';
const DRAWER_WIDTH_KEY = 'balus.aiAssistant.drawerWidth';

export class AIAssistantSettingsStorage {
  static getCustomSystemPrompt(): string {
    return localStorage.getItem(CUSTOM_PROMPT_KEY) ?? '';
  }

  static setCustomSystemPrompt(prompt: string): void {
    localStorage.setItem(CUSTOM_PROMPT_KEY, prompt);
  }

  static getDebugMessageEnabled(): boolean {
    return localStorage.getItem(DEBUG_MESSAGE_KEY) === 'true';
  }

  static setDebugMessageEnabled(enabled: boolean): void {
    localStorage.setItem(DEBUG_MESSAGE_KEY, enabled ? 'true' : 'false');
  }

  static getSelectedModel(): string | null {
    return localStorage.getItem(SELECTED_MODEL_KEY);
  }

  static setSelectedModel(modelId: string): void {
    localStorage.setItem(SELECTED_MODEL_KEY, modelId);
  }

  static getSelectedMode(): string | null {
    return localStorage.getItem(SELECTED_MODE_KEY);
  }

  static setSelectedMode(mode: string): void {
    localStorage.setItem(SELECTED_MODE_KEY, mode);
  }

  static getDrawerWidth(): number | null {
    const raw = localStorage.getItem(DRAWER_WIDTH_KEY);
    if (raw === null) return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  }

  static setDrawerWidth(width: number): void {
    localStorage.setItem(DRAWER_WIDTH_KEY, String(width));
  }
}
